import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appNonEditableTextArea]'
})
export class NonEditableTextAreaDirective {

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  // ngOnInit() {
  //   this.applyDirective();
  // }

  // private applyDirective() {
  //   if (!this.editable) {
  //     this.renderer.setProperty(this.elementRef.nativeElement, 'contenteditable', 'false');
  //   }
  // }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Prevent default behavior of the key event
    event.preventDefault();
  }
}
